import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LegendPosition, LineChartModule } from '@swimlane/ngx-charts';
import * as shape from 'd3-shape';
import { Observable, map } from 'rxjs';
import { ThemeType } from '../../../core/theme/theme-type';
import { textBlack, textWhite } from '../../../shared/color/color';
import { ThemeService } from './../../../core/theme/theme.service';
import { ChartSeriesDataItem } from './../chart-data-item';
import { NgStyle, AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-line-chart',
  templateUrl: './line-chart.component.html',
  styleUrls: ['./line-chart.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [LineChartModule, NgStyle, AsyncPipe],
})
export class LineChartComponent {
  @Input() chartSeriesDataItem: ChartSeriesDataItem[] = [];
  @Input() yAxisLabel?: string;
  @Input() curve = shape.curveBumpX;

  @Input() xAxis: boolean = true;
  @Input() yAxis: boolean = true;
  timeline: boolean = false;
  @Input() legend = true;

  @Input() scheme = 'picnic';

  style$: Observable<CSSStyleDeclaration>;

  LegendPosition = LegendPosition;

  constructor(private themeService: ThemeService) {
    this.style$ = this.themeService.onThemeChange$().pipe(
      map(() => {
        const style = {} as CSSStyleDeclaration;

        if (this.themeService.currentTheme === ThemeType.dark) {
          style.fill = textWhite;
        } else {
          style.fill = textBlack;
        }

        return style;
      })
    );
  }

  get showYAxisLabel() {
    return this.yAxisLabel !== undefined;
  }

  get customColors() {
    const result: any[] = [];

    for (const c of this.chartSeriesDataItem) {
      if (!c.color) {
        return undefined;
      }

      result.push({ name: c.name, value: c.color });
    }

    if (result.length === 0) {
      return undefined;
    }
    return result;
  }
}
